/**
 * Tyro approval durability.
 *
 * A card can be approved on the terminal and the POS still fail to record the
 * sale (tab closed, browser crash, network drop between APPROVED and
 * POST /api/sales). The customer is charged with nothing in the POS.
 *
 * The moment a sale is submitted with Tyro metadata we persist the exact
 * request — payload + idempotency key — to localStorage. It is cleared as
 * soon as the server confirms. Anything left behind is replayed on the next
 * POS load using the SAME idempotency key, so a sale that actually landed is
 * returned by the server instead of being created twice.
 */
const KEY = "tyro_pending_approvals";

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(-10)));
  } catch { /* storage full / private mode — nothing we can do */ }
};

export const listPendingApprovals = () => read();

/** entry: { id, kind: "sale" | "sale_payment", payload, idempotency_key, sale_id?, amount, tyro_ref, auth_code, at } */
export const savePendingApproval = (entry) => {
  const list = read().filter((e) => e.id !== entry.id);
  list.push({ ...entry, at: entry.at || new Date().toISOString() });
  write(list);
};

export const clearPendingApproval = (id) => {
  write(read().filter((e) => e.id !== id));
};
